export default __webpack_public_path__ + "static/media/doctor.e76b48b7.png";